module.exports = {"id":"230772","name":"Léo Gamalho","rating":"71","photo":"./data/images/photos/3/230772.png","club":{"name":"Pohang Steelers","logo":"./data/images/clubs/PohangSteelers.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LeoGamalho0.json
// module id = 2477
// module chunks = 0